export default __webpack_public_path__ + "static/media/beep.65841bb3.mp3";